import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/Newdatatable";
import { Select, Spin } from "antd";
// import dayjs from "dayjs";
import { getApiBaseUrl } from "../Config/Config";
const { Option } = Select;

const RetirementList = () => {
  const searchInputRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [retirementList, setRetirementList] = useState([]);
  const [retirementLoading, setRetirementLoading] = useState(true);
  const [selectedBlock, setSelectedBlock] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);

  const [blocks, setBlocks] = useState([]);
  const userType = JSON.parse(sessionStorage.getItem("UserType"));
  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/getLocationType`);
        const result = await response.json();
        if (result?.ResultData && result?.ResultData?.length > 0) {
          setBlocks(result?.ResultData);
          // setSelectedBlock(result?.ResultData[0].BlockId);
        }
      } catch (err) {
        console.error("Error fetching blocks:", err);
      }
    };
    fetchBlocks();
  }, []);

  const handleBlockChange = (blockId) => {
    setSelectedBlock(blockId);
  };

  const handleSearch = () => {
    const value = searchInputRef.current?.value?.trim() || "";
    setSearchTerm(value);
    setCurrentPage(1);
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // const user = JSON.parse(sessionStorage.getItem("user"));
  // Function to fetch retirement list
  const fetchRetirementList = async (page = 1, limit = 100, search = "") => {
    setRetirementLoading(true);
    try {
      const baseParams = `blockid=${selectedBlock}&ProcessType=${userType}&pageNumber=${page}&recordslimit=${limit}`;
      const searchParam = search.trim()
        ? `&Search=${encodeURIComponent(search.trim())}`
        : "&Search=";
      const response = await fetch(
        `http://192.168.1.100:8080/filterph2/getRetirement?${baseParams}${searchParam}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      const list = result?.ResultData || [];

      setRetirementList(list || []);
      if (list?.length > 0) {
        setTotalRecords(list[0]?.TotalCount || 0);
      }
    } catch (err) {
      console.log(err.message || "Something went wrong");
      setRetirementList([]);
      setTotalRecords(0);
    } finally {
      setRetirementLoading(false);
    }
  };

  useEffect(() => {
    console.log("cvvvvvvvvvvvvvvvvvvvvvvv");

    const handleFilterChange = () => {
      console.log("pppppppppppppppppppppppppppppppppppp");
      fetchRetirementList();
    };

    window.addEventListener("filtertypechange", handleFilterChange);

    return () => {
      window.removeEventListener("filtertypechange", handleFilterChange);
    };
  }, []);
  // Call fetch on component mount

  useEffect(() => {
    fetchRetirementList(currentPage, pageSize, searchTerm);
  }, [selectedBlock, currentPage, pageSize, userType, searchTerm]);

  const columns = [
    {
      title: "Filter ID",
      dataIndex: "Lable",
      key: "Lable",
      sorter: (a, b) => a?.Lable?.length - b?.Lable?.length,
    },
    // {
    //   title: "Code ",
    //   dataIndex: "AHUcode",
    //   key: "AHUcode",
    //   sorter: (a, b) => a.AHUcode - b.AHUcode,
    // },

    {
      title: "Block",
      dataIndex: "locatinname",
      key: "locatinname",
      sorter: (a, b) => a.locatinname.localeCompare(b.locatinname),
    },
    {
      title: " User ID",
      dataIndex: "UserName",
      key: "UserName",
      sorter: (a, b) => a.UserName.localeCompare(b.UserName),
    },
    // {
    //   title: "Status",
    //   dataIndex: "StageName",
    //   key: "StageName",
    //   render: (text) => <span className="badge bg-danger">{text}</span>,
    // },
    // {
    //   title: "Last Change",
    //   dataIndex: "LastCleaningDate",
    //   key: "LastCleaningDate",
    //   sorter: (a, b) =>
    //     new Date(a.LastCleaningDate) - new Date(b.LastCleaningDate),
    //   render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
    // },
    {
      title: "Retired Date",
      dataIndex: "updatedon",
      key: "updatedon",
      render: (value) => {
        if (!value) return "";
        const d = new Date(value);

        // Extract UTC parts to avoid local timezone changes
        const day = String(d.getUTCDate()).padStart(2, "0");
        const month = String(d.getUTCMonth() + 1).padStart(2, "0");
        const year = d.getUTCFullYear();

        return `${day}/${month}/${year}`;
      },
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      sorter: (a, b) => a.remarks.localeCompare(b.remarks),
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
        </span>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Retirement List
                  </h4>
                </ol>
              </nav>
              <h6>Manage Retirement List</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li></li>
          </ul>
        </div>

        <div className="card table-list-card  no-search">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
            <div className="search-set m-3">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search filters..."
                  ref={searchInputRef}
                  onKeyPress={handleKeyPress}
                  defaultValue={searchTerm}
                />
                <button
                  className="btn btn-primary btn-sm"
                  onClick={handleSearch}
                  disabled={retirementLoading}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div style={{ minWidth: "250px" }}>
                <label className="fw-bold mb-1 d-block">Select Block:</label>
                <Select
                  style={{ width: "100%" }}
                  value={selectedBlock === 0 ? 0 : selectedBlock} // Ensures "All" is shown when value is 0
                  onChange={handleBlockChange}
                  placeholder="Select Block"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option value={0}>All</Option>
                  {blocks.map((block) => (
                    <Option key={block.BlockId} value={block.BlockId}>
                      {block.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {retirementLoading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : retirementList?.length > 0 ? (
                <Table
                  columns={columns}
                  dataSource={retirementList}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  totalRecords={totalRecords}
                  onPageChange={(page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  }}
                />
              ) : (
                <div className="text-center my-4">
                  <p>No data available</p>
                </div>
              )}

              {/* <Table columns={columns} dataSource={RetirementListData} /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetirementList;
